import { recruiter_base_url } from "@/store/urls/base_urls";

export const GET_ALL_CANDIDATES = recruiter_base_url + "search-candidates/";

export const CANDIDATE_ACTION = recruiter_base_url + "action-candidate/";
